import { quiz } from '../constants';

const {
  SET_QUIZ_DATA,
  SET_QUIZ_STATE
} = quiz;

const actions = {
  setQuizData: (data) => ({ type: SET_QUIZ_DATA, data }),
  setQuizState: (data) => ({ type: SET_QUIZ_STATE, data }),
};

// eslint-disable-next-line import/prefer-default-export
export const setQuizData = (data) => (dispatch) => {
  dispatch(actions.setQuizData(data));
};

export const setQuizState = (data) => (dispatch) => {
  dispatch(actions.setQuizState(data));
};
